import {api} from "../resources"

export default {
    namespaced: true,
    state: {
        transfers: []
    },
    getters: {},
    actions: {
        addTransfer({}, data) {
            return api.transfers.save(data);
        },
        removeTransfer({}, id) {
            return api.transfers_id.delete({id});
        },
        updateTransfer({}, data) {
            return api.transfers_id.update({id:data.id},{...data});
        },
        getTransfers({commit}){
            api.transfers.get().then(res=>{
                if(res.body.success){
                    commit('setTransfers',res.body.data);
                }
            })
        }

    },
    mutations: {
        setTransfers(state, data) {
            state.transfers = data;
        }
    }
}
